
export const color_lookup = colorname => {
  return " bg-" + colorname
}
